import { PriceContainer } from '../../containers/advancedFilters/PriceContainer';
import { IFilter } from '../../types/advancedFilters';

export const price: IFilter = {
  component: PriceContainer,
};
